import api from './api';

function getHost() {
  const base = api.defaults.baseURL || '';
  try {
    const u = new URL(base);
    return `${u.protocol}//${u.host}`;
  } catch {
    return '';
  }
}

function buildHeader(refererPath) {
  const host = getHost();
  const lang = localStorage.getItem('vd-lang') || 'es_es';
  return {
    acceptLanguage: "es-ES",
    externalReferer: `${host}/login`,
    lang,
    referer: `${host}${refererPath}`,
    userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/147.0.0.0 Safari/537.36",
    product: "Gecko",
    platform: "Win32",
    vendor: "Google Inc.",
    token: null,
    version: null
  };
}

export const dashboardService = {
  async getSegmentMetadata(segmentId) {
    if (!segmentId) throw new Error('Missing segmentId for metadata request.');

    const timestamp = Date.now();
    const payload = {
      requestHeader: buildHeader(`/segment/segment-management/search-segment/get/${segmentId}`),
      requestContent: { id: segmentId }
    };

    try {
      const response = await api.post(`${timestamp}/segment/builder/get`, payload);
      return response.data;
    } catch (err) {
      if (err.response?.status === 401) {
        const fallback = await api.post(`${timestamp}/segment/dashboard/get`, payload);
        return fallback.data;
      }
      throw err;
    }
  },

  async getDashboardStats(segmentId, jsonData, options = {}) {
    if (!segmentId || !jsonData) {
      throw new Error('Missing segmentId or jsonData for the request.');
    }

    const timestamp = Date.now();
    const dimensions = Array.isArray(jsonData) ? jsonData : [jsonData];
    // Opt-in por widget: si el widget pide bucket "sin dato" y/o agregaciones
    // numéricas, enviamos un objeto { dimensions, includeMissing, missingLabel,
    // metrics } en vez del array plano. El backend acepta ambas formas (array =
    // comportamiento clásico, no altera los demás widgets).
    //   metrics: [{ field: 'vipCosts.costEuros', funcs: ['SUM','AVG'] }, ...]
    //   → cada (field × func) = una sub-agg del bucket de la dimensión.
    const metrics = Array.isArray(options.metrics)
      ? options.metrics.filter(m => m && m.field && Array.isArray(m.funcs) && m.funcs.length)
      : [];
    let requestJsonData = dimensions;
    if (options.includeMissing || metrics.length) {
      requestJsonData = { dimensions };
      if (options.includeMissing) {
        requestJsonData.includeMissing = true;
        if (options.missingLabel) requestJsonData.missingLabel = options.missingLabel;
      }
      if (metrics.length) requestJsonData.metrics = metrics;
    }

    const payload = {
      requestHeader: buildHeader(`/segment/segment-management/search-segment/get-dashboard/${segmentId}`),
      requestContent: {
        id: segmentId,
        code: null,
        jsonData: requestJsonData
      }
    };

    const response = await api.post(`${timestamp}/segment/dashboard/task`, payload);
    return response.data;
  }
};
